import React from 'react';
import { FaStar } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Bárbara Felício',
      location: 'SP',
      date: '25/8/2025',
      rating: 5,
      text: 'Na verdade, tudo, a facilidade de fazer todo o pedido via WhatsApp, a rapidez na entrega da bateria e todo o suporte. Excelente, estão de parabéns'
    },
    {
      id: 2,
      name: 'Leandro César Garros Monteiro',
      location: 'MA',
      date: '24/8/2025',
      rating: 5,
      text: 'Compra realizada totalmente de forma virtual e sem falhas, no horário e local correto'
    },
    {
      id: 3,
      name: 'Evelize Taborda Ribas',
      location: 'PR',
      date: '23/8/2025',
      rating: 5,
      text: 'Foi tudo muito correto. Pontualidade e atendimento excelentes'
    }
  ];

  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  return (
    <section className="testimonials">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Opiniões de quem já pediu
          </h2>
        </div>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-header">
                <div className="customer-avatar">
                  {getInitials(testimonial.name)}
                </div>
                <div className="customer-info">
                  <h3 className="customer-name">
                    {testimonial.name}, {testimonial.location}
                  </h3>
                  <span className="testimonial-date">{testimonial.date}</span>
                </div>
              </div>
              
              <div className="rating">
                {[...Array(testimonial.rating)].map((_, index) => (
                  <FaStar key={index} className="star" />
                ))}
              </div>
              
              <p className="testimonial-text">{testimonial.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
